import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import styles from "./PassportPartPhoto.module.css";

//Reusable Section
import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";

import { useEffect, useState } from "react";
import save_icon from "../../../assets/images/icons/save_icon.png";
import PassportPartPhotoReusable from "./PassportPartPhoto_Reusable";

import { useNavigate, useParams } from "react-router-dom";

import useAxios from "../../Hooks/useAxios";
const PassportPartPhoto = () => {
  const { product_id } = useParams();
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [count, setCount] = useState(0);
  const [item, setItem] = useState({});

  let [editState, setEditState] = useState([]);
  let defaultStateSingleProduct = {
    name: "",
    date: "",
    time: "",
    height: "",
    weight: "",
    copied: false,
  };

  const [copyDetails, setCopyDetails] = useState([]);
  const changeEditState = (index, state) => {
    const temp = Array.from(editState);
    temp[index] = state;
    setEditState(temp);
  };

  const confirmEdits = () => {
    
    console.log("Confirm Edits. Send to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }

    console.log("PREVIEW IMAGES HERE:");
    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));

    data.append("copy_details", JSON.stringify(copyDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Posted THE EDIT DATA");
          console.log(res.data);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", { state: { title : "パーツフォト", subtitle : "", count : count, address : "", item : item } });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveToServer = () => {
    console.log("Send This to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
      copy_details: JSON.stringify(copyDetails),
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(design);
          console.log(design.design_status);
          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
            setCopyDetails(JSON.parse(design.copy_details));
          } else {
            let tempState = [];
            let tempCopyDetails = [];
            for (let i = 0; i < res.data.quantity; i++) {
              const temp = { ...defaultStateSingleProduct };
              tempState.push(temp);
              tempCopyDetails.push(i + 1);
            }
            setEditState(tempState);
            setCopyDetails(tempCopyDetails);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const changeCopyDetails = (details, index) => {
    console.log("CHANGE COPY DETAILS");
    console.log(index);
    console.log(details);
    const newDetails = JSON.parse(JSON.stringify(copyDetails));
    newDetails[index] = details;
    setCopyDetails(newDetails);
    changeEditState(index, JSON.parse(JSON.stringify(editState[details - 1])));
  };
  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      <div className={styles.wooden_square_edit_screen_main_div}>
        {count > 0 && (
          <div onClick={saveToServer} className={styles.save_box_main}>
            <img
              src={save_icon}
              className={styles.save_icon_image}
              alt="save"
            />
          </div>
        )}
        <DesignBoxNavigationCrumb active={3} />
        <EditScreenItemHeaderDiv
          title={"パーツフォト"}
          subtitle={""}
          count={count}
          address={"会員様住所"}
          item={item}
        />
        <EditScreenHeaderInfoDiv lines={["記載する情報を記入してください。"]} />
        {Array.isArray(editState) &&
          editState.length > 0 &&
          editState.map((item, index) => {
            return (
              <PassportPartPhotoReusable
                key={index}
                index={index}
                callback={changeEditState}
                state={item}
                //new stuff
                saveThisProduct={saveToServer}
                changeCopyDetails={changeCopyDetails}
                selectedCopyDetails={copyDetails[index]}
                currentPageNumber={index + 1}
                totalPageNumber={count}
                confirmEdits={confirmEdits}
              />
            );
          })}
      </div>

      <Footer />
    </>
  );
};
export default PassportPartPhoto;
